import { ApiTags, rootApi } from "../../../../services/rootApi";
import { IProgramStructure, Course, ISemesterRegistration } from "./IProgramStructure";
const TAG = ApiTags.ShuttleBooking;

const getTags = (entities: IProgramStructure[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.programRequirementId })),
  TAG,
];

const getTags1 = (entities: Course[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.courseId })),
  TAG,
];

const getTags2 = (entities: ISemesterRegistration[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.registrationId })),
  TAG,
];

const programStructureApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getProgramStructure: builder.query<IProgramStructure[], void>({
      query: () => "/ProgramStructure",
      providesTags: (result) => (result ? getTags(result) : [TAG]),
    }),

    getProgStructureBySemesterProgramSessionType: builder.query<IProgramStructure[], { semesterId: string, programId: string, academicSession: string, coursesType: string, section: string }>({
      query: ({ semesterId, programId, academicSession, coursesType, section }) => `/ProgramStructure/(${semesterId})/(${programId})/(${academicSession})/(${coursesType})/(${section})`, // Assuming the API path to fetch all program structures
      providesTags: (result) => (result ? getTags(result) : [TAG]),
    }),

    getCourses: builder.query<Course, { courseId: string }>({
      query: ({ courseId }) => `/ProgramStructure/(${courseId})`,
      providesTags: (result) => (result ? getTags1([result]) : [TAG]),
    }),

    getSemesterRegistration: builder.query<ISemesterRegistration[], { studentId: string, academicSession: string }>({
      query: ({ studentId, academicSession  }) => `/ProgramStructure/(${studentId})/(${academicSession})`, // Assuming the API path to fetch all program structures
      providesTags: (result) => (result ? getTags2(result) : [TAG]),
    }),

  }),
});

export const {
  useGetProgramStructureQuery,
  useGetProgStructureBySemesterProgramSessionTypeQuery,
  useLazyGetProgStructureBySemesterProgramSessionTypeQuery,
  useGetCoursesQuery,
  useGetSemesterRegistrationQuery,
  useLazyGetCoursesQuery,
} = programStructureApi;
